import getSponsoredProducts from "./getSponsoredProducts";

const getSponsoredProductIds = (state) =>
  (getSponsoredProducts(state) || [])
    .map((product) => product.advertisement.variantId)
    .join("|");

export default getSponsoredProductIds;
